// radio_field_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String }

  connect() {
    this.inputs = this.element.querySelectorAll("input[type=radio]");
    this.inputs.forEach(input =>
      input.addEventListener("change", this.broadcastChange.bind(this))
    );
    console.log("Radio Button Pair Controller connected");
  }

  broadcastChange(event) {
    const value = event.target.value;

    this.element.dispatchEvent(new CustomEvent("field:changed", {
      bubbles: true,
      detail: {
        key: this.keyValue,
        value: value
      }
    }));
  }
}
